import React, { useState } from 'react';
import { useElements, useStripe } from '@stripe/react-stripe-js';
import LowCreditModal from '../../components/LowCreditModal/LowCreditModal';
import Footer from '../../components/Common/Footer';
import NavigationBar from '../../components/NavigationBar/NavigationBar';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { makePayment } from './services/Credit.service';

const Profile = () => {
  const user = useSelector((state: RootState) => state.user.user);
  const stripe = useStripe();
  const elements = useElements();

  const [paymentLoader, setPaymentLoader] = useState<boolean>(false);
  const [showLowCreditModal, setShowLowCreditModal] = useState<boolean>(true);
  const handlePayment = async () => makePayment(stripe, elements, user, setPaymentLoader);

  return (
    <div className="App mx-auto">
      <NavigationBar />
      <div className="bg-storytan p-0 md:p-4 mx-auto">
        <div className="max-w-7xl mx-auto pt-4 md:pt-0 px-4 sm:px-6 lg:px-8">
          <LowCreditModal
            showLowCreditModal={showLowCreditModal}
            setShowLowCreditModal={setShowLowCreditModal}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Profile;
